import ListResult from "../homepage/featured/listing";
import { listView } from "../shared/util";
import PropTypes from "prop-types";
import React from "react";
import { INDEX_TYPES } from "../../constants/constants";

class ListView extends React.Component {
  render() {
    let results = this.props.results
      .filter(
        (r) =>
          r.listingType === INDEX_TYPES.RENTAL ||
          r.listingType === INDEX_TYPES.SALE
      )
      .map((r, index) => (
        <ListResult key={index} index={index} listing={r} options={listView} />
      ));
    return (
      <div className="featured-listings">
        <div className="container results-view">
          <div className="row">{results}</div>
        </div>
      </div>
    );
  }
}

ListView.propTypes = {
  results: PropTypes.array.isRequired,
  state: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default ListView;



// WEBPACK FOOTER //
// ./src/components/quicksearch/list-view.js